import { useEffect, useState } from "react";
import { BAR_STAGES, STAGE_NAMES } from "../../../../lib/giftingRules";
import type { GfStage } from "../../../../types/gifting";
import { ConfirmModal } from "../../modals/ConfirmModal";
import { GfField } from "../../ui/GfUi";

/** 一括「段階を戻す」。選択中の全件を同じ段階に直接変更する（現在と同じ段階の行はスキップ）。履歴に理由が残る */
export function BulkStageModal({
  open,
  count,
  busy,
  onConfirm,
  onClose,
}: {
  open: boolean;
  count: number;
  busy: boolean;
  onConfirm: (stage: GfStage, note: string) => void;
  onClose: () => void;
}) {
  const [stage, setStage] = useState<GfStage>(1);
  useEffect(() => {
    if (open) setStage(1);
  }, [open]);
  return (
    <ConfirmModal
      open={open}
      title={`${count}件の段階を戻す／修正する`}
      message="誤操作の取り消しなど、選択中の案件の段階を直接変更します。履歴に理由が残ります。現在と同じ段階の案件は変更しません。"
      confirmLabel="段階を変更する"
      requireNote
      busy={busy}
      onConfirm={(note) => onConfirm(stage, note)}
      onClose={onClose}
    >
      <GfField label="変更後の段階">
        <select className="gf-select" value={stage} onChange={(e) => setStage(Number(e.target.value) as GfStage)}>
          {BAR_STAGES.map((s) => (
            <option key={s} value={s}>
              {s} {STAGE_NAMES[s]}
            </option>
          ))}
        </select>
      </GfField>
    </ConfirmModal>
  );
}
